export const INTAKE_MEETING_SCHEDULED_STORAGE_KEY = 'intakeMeetingScheduled';
